var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"fr-note-row\">\n    <input class=\"fr-search-input\" type=\"text\" placeholder=\"Search ...\" value=\""
    + container.escapeExpression(((helper = (helper = helpers.searchTerm || (depth0 != null ? depth0.searchTerm : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"searchTerm","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableSearch : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n</div>\n\n<div class=\"fr-note-row\">\n    <label class=\"\">Note Type:</label>\n    <div class=\"fr-note-type-select-region\" data-region=\"true\"></div>\n</div>\n\n<div class=\"fr-search-note-properties-region fr-note-row\" data-region=\"true\"></div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/searchModelView/template.hbs
 ** module id = 610
 ** module chunks = 0
 **/